var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/61b1d804e7026265d8bfbf63d853630f.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ff9a11f0436512d2127ce1d94b2d4dd8.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    